// Tiny module: kind labels only, so route head()/components can import them
// without pulling the full NEAR_PLACES corpus into the client entry bundle.
export type NearPlaceKind = "bts" | "mrt" | "arl" | "mall";

export const NEAR_PLACE_KIND_LABEL: Record<NearPlaceKind, string> = {
  bts: "สถานี BTS",
  mrt: "สถานี MRT",
  arl: "สถานี ARL",
  mall: "ห้างสรรพสินค้า",
};
